import "react-dropzone-component/styles/filepicker.css"
import "dropzone/dist/min/dropzone.min.css"
import React from 'react';
import DropzoneComponent from 'react-dropzone-component';
import * as DocumentStorageActions from '../../actions/documentStorage';
import * as ImageUploadActions from '../../actions/imageUpload';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

const MAX_UPLOAD_SIZE = 100; // = 100MB
const POST_UPLOAD_URL = '/api/imageupload';

// default config
let uploadConfig = {
    config: {
        maxFileSize: MAX_UPLOAD_SIZE,
        allowedMimeTypes: ['image/*'],
    },
    configurator: {
        width: 400,
        height: 300,
        imageKey: null,
        iconFileTypes: [],
    },
    pdf: {
    }
};

class UploadImage extends React.Component {

    constructor(props, context) {
        super(props, context);

        // For a full list of possible configurations,
        // please consult http://www.dropzonejs.com/#configuration
        this.djsConfig = {
            addRemoveLinks: false,
            acceptedFiles: "image/*",
            maxFilesize: MAX_UPLOAD_SIZE, // in MB
            filesizeBase: 1024,
            uploadMultiple: false,
            maxFiles: 1,
            dictDefaultMessage: props.intl.formatMessage({id: 'TEXT_UPLOAD_DROPZONE'}),
            dictInvalidFileType: props.intl.formatMessage({id: 'ERROR_UPLOAD_MIMETYPE'}),
            dictFileTooBig: props.intl.formatMessage({id: 'ERROR_UPLOAD_MAXFILESIZE'}),   // Shown when the file is too big. {{filesize}} and {{maxFilesize}} will be replaced."
            paramName: 'image',
            createImageThumbnails: false,
            params: {
                uploadSettingRef: null,
                documentStorageId: null,
            }
        };

        this.componentConfig = {
            postUrl: POST_UPLOAD_URL
        };

        this.addedFile = file => {
            //
        };

        this.success = (file, response) => {

            const {uploadWidgetId, ConfiguratorManager, areaId, dispatch, user} = props;

            if (response && response.id && response.imagesGenerated && response.imagesGenerated[`${uploadConfig.configurator.imageKey}`]) {

                const updatedStorage = ConfiguratorManager.addUploadToStorage(areaId, uploadWidgetId, response.id, user.userId);

                dispatch(DocumentStorageActions.updateDocumentStorage(
                    ConfiguratorManager.getStorageId(), null, null, updatedStorage)
                );

                dispatch(ImageUploadActions.addImageUpload(response));

            } else {
                alert('Upload ERROR');
            }

        };

        this.removedfile = file => {
            // we dont need this callback because we handle the file removes in our own handler
        };

        this.error = (file, error, response) => {

            let uploadErrors = [];
            if (error instanceof Object && error.msg) {
                uploadErrors.push(error.msg);
            } else if (typeof error === 'string') {
                uploadErrors.push(error);
            } else {
                uploadErrors.push('An unexpected upload error');
            }

            if (uploadErrors.length > 0) {
                // remove in error case the file from dropzone to avoid errors in the dropzone
                this.dropzone.removeFile(this.dropzone.files[0]);

                // TODO ... beutify error message
                alert("Upload Error:\n" + uploadErrors.join("\n"));
            }
        };

        this.dropzone = null;
    }

    static get defaultProps() {
        return {
            uploadSettingRef: null,
            uploadWidgetId: null,
            ConfiguratorManager: {},
            areaId: null
        }
    }

    componentWillMount() {

        let {uploadSettingRef, uploadWidgetId, ConfiguratorManager, areaId, dispatch} = this.props;

        const config = uploadSettingRef ? ConfiguratorManager.getUploadSettingById(uploadSettingRef) : {};

        // merge default config with defined config
        if (config && config.config && config.config.maxFileSize) {
            uploadConfig.config.maxFileSize = config.config.maxFileSize;
        }
        if (config && config.config && config.config.allowedMimeTypes &&
            config.config.allowedMimeTypes instanceof Array && config.config.allowedMimeTypes.length > 0) {
            uploadConfig.config.allowedMimeTypes = config.config.allowedMimeTypes;
        }
        if (config && config.configurator && config.configurator.width) {
            uploadConfig.configurator.width = parseFloat(config.configurator.width);
        }
        if (config && config.configurator && config.configurator.height) {
            uploadConfig.configurator.height = parseFloat(config.configurator.height);
        }
        if (config && config.configurator && config.configurator.iconFileTypes) {
            uploadConfig.configurator.iconFileTypes = config.configurator.iconFileTypes;
        }
        if (config && config.configurator && config.configurator.imageKey) {
            uploadConfig.configurator.imageKey = config.configurator.imageKey;
        }
        if (uploadSettingRef) {
            this.djsConfig.params.uploadSettingRef = uploadSettingRef;
        }

        this.djsConfig.params.documentStorageId = ConfiguratorManager.getStorageId();


        // map to djsConfig
        this.djsConfig.maxFilesize = uploadConfig.config.maxFileSize;
        this.djsConfig.acceptedFiles = uploadConfig.config.allowedMimeTypes.join(',');
        this.djsConfig.thumbnailWidth = uploadConfig.configurator.width;
        this.djsConfig.thumbnailHeight = uploadConfig.configurator.height;

        //map to component config
        if (uploadConfig.configurator.iconFileTypes && uploadConfig.configurator.iconFileTypes instanceof Array && uploadConfig.configurator.iconFileTypes.length > 0) {
            this.componentConfig.showFiletypeIcon = true;
            this.componentConfig.iconFiletypes = uploadConfig.configurator.iconFileTypes;
        }

        // init file, if exists in documentStorage && flag in redux state that this widget is already load
        const storedImageUploadId = this.getStoredImageUploadId();
        const widgetId = this.getWidgetId();
        if (storedImageUploadId) {
            dispatch(ImageUploadActions.getImageUpload(
                storedImageUploadId,
                widgetId
            ));
        } else {
            dispatch(ImageUploadActions.loadingWidgetSuccess(widgetId));
        }
    }

    /**
     * Delete the file by given id and delete reference in documentStorage
     * @param imageId
     */
    deleteFile(imageId) {

        let {dispatch, ConfiguratorManager, areaId, uploadWidgetId} = this.props;
        dispatch(ImageUploadActions.deleteImageUpload(
            imageId
        ));

        const updatedStorage = ConfiguratorManager.removeUploadFromStorage(areaId, uploadWidgetId);
        dispatch(DocumentStorageActions.updateDocumentStorage(
            ConfiguratorManager.getStorageId(), null, null, updatedStorage)
        );
    }

    /**
     * Returns the stored imageUploadId in the document storage for this upload widget
     *
     * @returns null|string
     */
    getStoredImageUploadId() {
        let {uploadWidgetId, ConfiguratorManager, areaId, dispatch, imageUpload} = this.props;
        const storedImageUpload = ConfiguratorManager.getUploadFromStorage(areaId, uploadWidgetId);

        if (storedImageUpload && storedImageUpload.id) {
            return  storedImageUpload.id
        }

        return null;
    }

    /**
     * Create and return an global unique widget id for this upload component
     *
     * @returns {string}
     */
    getWidgetId() {
        let {uploadWidgetId, ConfiguratorManager, areaId} = this.props;

        const pageId = ConfiguratorManager.getPageId();
        const storageId = ConfiguratorManager.getStorageId();

        return (storageId + '-' + pageId + '-' + areaId + '-' + uploadWidgetId).toString().toLowerCase();
    }

    /**
     * Return the stored imageUpload object, if exists
     *
     * @returns {*}
     */
    getStoredImageUpload() {
        const { imageUpload } = this.props;
        const id = this.getStoredImageUploadId();

        let storedImage = null;
        if (id && imageUpload && imageUpload.data && imageUpload.data.length > 0) {
            imageUpload.data.map(entry => {
                if (entry.id.toString() === id.toString()) {
                    storedImage = entry;
                }
            })
        }

        return storedImage;
    }

    /**
     * Check if this widget component is already loaded
     *
     * @returns {boolean}
     */
    isWidgetLoaded() {
        let loaded = false;
        const { imageUpload } = this.props;

        if (imageUpload && imageUpload.loadingWidgets && imageUpload.loadingWidgets.length > 0) {
            imageUpload.loadingWidgets.map(entry => {
                if (entry.toString() === this.getWidgetId()) {
                    loaded = true;
                }
            })
        }

        return loaded;
    }


    /**
     * Render method
     *
     * @returns {XML}
     */
    render() {
        let {uploadSettingRef, uploadWidgetId, ConfiguratorManager, areaId} = this.props;
        let storedImage = this.getStoredImageUpload();

        // Some checks if dropzone settings valid
        let renderError = [];

        const uploadSetting = uploadSettingRef ? ConfiguratorManager.getUploadSettingById(uploadSettingRef) : null;

        if (!uploadSettingRef) {
            renderError.push("The imageupload component required the uploadsettingsref attribute");
        }
        if (!uploadWidgetId) {
            renderError.push("The imageupload component required the uploadwidgetid attribute");
        }
        if (!uploadSetting && uploadSettingRef) {
            renderError.push("No uploadSetting definition found for \"uploadSettingRef\"");
        }
        if (uploadSetting && !uploadConfig.configurator.imageKey) {
            renderError.push("The \"configurator.imageKey\" is required in the uploadSettings");
        }
        if (uploadConfig.configurator.imageKey) {
            const imageKeyObject = ConfiguratorManager.getImageKey(uploadConfig.configurator.imageKey);
            if (!imageKeyObject) {
                renderError.push("The imageKey \"" + uploadConfig.configurator.imageKey + "\" is not valid");
            }
        }

        let wrapperStyle = {
            width: uploadConfig.configurator.width + 'px',
            height: uploadConfig.configurator.height + 'px'
        };
        let wrapperClassname = "uploadimage";
        let renderContent = null;
        if (renderError.length > 0) {
            wrapperClassname += ' error';
            renderContent = <div>
                <h5>ERROR</h5>
                <p>{ renderError.join(', ') }</p>
            </div>
        } else if (!this.isWidgetLoaded()) {
            wrapperClassname += ' init';
            renderContent = <div>
                <p>init dropzone ...</p>
            </div>
        } else if (storedImage) {
            wrapperClassname += ' thumbnail';
            let imgSrc = storedImage.imagesGenerated[`${uploadConfig.configurator.imageKey}`];
            renderContent = <div>
                <img src={imgSrc} width={uploadConfig.configurator.width} height={uploadConfig.configurator.height} />
                <button className="btn-area-element-delete" onClick={() => this.deleteFile(storedImage.id)}><i className="material-icons">delete</i></button>

            </div>
        } else {
            wrapperClassname += ' dropzone';
            const config = this.componentConfig;
            const djsConfig = this.djsConfig;

            // For a list of all possible events (there are many), see README.md!
            const eventHandlers = {
                init: dz => this.dropzone = dz,
                addedfile: this.addedFile,
                success: this.success,
                error: this.error,
                removedfile: this.removedfile
            };

            renderContent = <DropzoneComponent config={config}
                               eventHandlers={eventHandlers}
                               djsConfig={djsConfig}
            />
        }

        return <div style={wrapperStyle} className={wrapperClassname}>{ renderContent }</div>
    }
}


export default connect(state => ({ documentStorage: state.documentStorage, user: state.user, imageUpload: state.imageUpload }))(injectIntl(UploadImage))


// WEBPACK FOOTER //
// ./src/js/components/configuratorElements/UploadImage.react.jsx